// The chooser shown when a login can open more than one thing on geaar.app.
//
// It is only ever navigation. The server has already filtered the list, and each tool checks
// the session cookie and its own allow-list when you arrive - a card is a shortcut, not a
// key. Which is why this file has no notion of who you are: by the time it runs, that
// question has been answered twice.
import type { Tool } from "../api";

// Named parameters rather than "any query string", so an unrelated tracking or cache-busting
// parameter cannot silently disable the launcher for someone.
export function deepLinked(): boolean {
  const q = new URLSearchParams(location.search);
  return q.has("tool") || q.has("present");
}

export function showLauncher(tools: Tool[]): void {
  document.querySelector(".launcher-overlay")?.remove(); // reopening replaces, never stacks

  const overlay = document.createElement("div");
  overlay.className = "launcher-overlay";
  overlay.innerHTML = `
    <div class="launcher">
      <h1>GEAAR</h1>
      <p class="launcher-sub">Choose a tool</p>
      <div class="launcher-cards"></div>
    </div>`;

  const cards = overlay.querySelector(".launcher-cards")!;
  for (const t of tools) {
    const card = document.createElement("a");
    card.className = "launcher-card";
    // The Review Station is this same app, so it carries ?tool so the launcher does not
    // immediately reappear on arrival. Other tools are separate services on the domain.
    card.href = t.url === "/" ? "/?tool=review-station" : t.url;

    // textContent, not innerHTML: tools.json is ours, but a name is still data and data does
    // not belong in a markup string.
    const name = document.createElement("span");
    name.className = "launcher-card-name";
    name.textContent = t.name;
    const blurb = document.createElement("span");
    blurb.className = "launcher-card-blurb";
    blurb.textContent = t.blurb;
    const go = document.createElement("span");
    go.className = "launcher-card-go";
    go.textContent = "Open →";

    card.append(name, blurb, go);
    cards.append(card);
  }
  document.body.append(overlay);
}
